/* jshint esnext: true */

const states = {

	/**
	 * The current state.
	 */
	currentState: '',


	/**
	 * Initialize the states and pick the default one.
	 */
	init: function() {

		// Hide all states.
		this.hideAll();

		// Show the default one.
		this.set();

		$( '.game-states' ).removeClass( 'states-hidden' );

		// console.log( 'states init ' );

	},


	/**
	 * Set the current state.
	 */
	set: function( state = 'main-menu' ) {

		// Process the state change.
		state = stateController.set( state );

		if ( !state ) {
			return;
		}

		// Disable the current wrapper.
		$( '.state-wrapper' )
			.addClass( 'disabled' );

		setTimeout(
			this.display,
			200
		);

	},


	/**
	 *
	 */
	display: function() {

		states.hideAll();

		$( '.state-wrapper' )
			.removeClass( 'disabled' );

		$( '.state-' + stateController.currentState )
			.show();

	},


	/**
	 * Hide all state wrappers.
	 */
	hideAll: function() {

		$( '.state-wrapper' )
			.removeClass( 'active' )
			.hide();

	}

};